"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const ParagraphComponent_1 = require("../../commonFiles/PageComponents/ParagraphComponent");
const HeaderComponent_1 = require("../../commonFiles/PageComponents/HeaderComponent");
const TitleComponent_1 = require("../../commonFiles/PageComponents/TitleComponent");
const ImageComponent_1 = require("../../commonFiles/PageComponents/ImageComponent");
const LinkComponent_1 = require("../../commonFiles/PageComponents/LinkComponent");
const YoutubeEmbedComponent_1 = require("../../commonFiles/PageComponents/YoutubeEmbedComponent");
const SeperatorComponent_1 = require("../../commonFiles/PageComponents/SeperatorComponent");
const QuoteComponent_1 = require("../../commonFiles/PageComponents/QuoteComponent");
const structure_1 = require("../../commonFiles/PageComponents/structure");
const componentsTypes = {
    [structure_1.ParagraphComponentClass]: { Render: ParagraphComponent_1.ParagraphComponentRender },
    [structure_1.HeaderComponentClass]: { Render: HeaderComponent_1.HeaderComponentRender },
    [structure_1.TitleComponentClass]: { Render: TitleComponent_1.TitleComponentRender },
    [structure_1.ImageComponentClass]: { Render: ImageComponent_1.ImageComponentRender },
    [structure_1.LinkComponentClass]: { Render: LinkComponent_1.LinkComponentRender },
    [structure_1.YoutubeEmbedComponentClass]: { Render: YoutubeEmbedComponent_1.YoutubeEmbedComponentRender },
    [structure_1.SeperatorComponentClass]: { Render: SeperatorComponent_1.SeperatorComponentRender },
    [structure_1.QuoteComponentClass]: { Render: QuoteComponent_1.QuoteComponentRender },
};
function PageContentRender(props) {
    const pageContent = props.pageContent;
    const render = props.render;
    const darkMode = props.darkMode;
    react_1.default.useEffect(() => {
        console.log('PageContentRender', pageContent);
    }, []);
    return react_1.default.createElement("div", { className: `mx-auto ${darkMode ? 'bg-dark' : 'bg-white'} border p-1 m-1 rounded shadow ` },
        react_1.default.createElement(react_bootstrap_1.Col, { xs: 10, className: 'mx-auto' }, pageContent === null || pageContent === void 0 ? void 0 : pageContent.pageComponents.map((pageComponent, index) => {
            if (componentsTypes[pageComponent.class]) {
                let Render = componentsTypes[pageComponent.class].Render;
                return react_1.default.createElement(Render, { key: index, originalDir: pageContent.originalDir, translatedDir: pageContent.translatedDir, render: render, className: darkMode ? 'text-white bg-dark' : '', component: pageComponent });
            }
        })));
}
exports.default = PageContentRender;
